import React from "react";
import PropTypes from "prop-types";
import FeedLockIcon from "../../../containers/feed_lock_icon";

const overlayStyle = {
  top: 0,
  left: 25,
  right: 0,
  bottom: 0,
  paddingRight: 25,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#ffffff90',
  fontFamily: '"Cerebri Sans", Arial, san-serif',
  fontWeight: 500,
};

const overlayButtonStyle = {
  width: 130,
  height: 70,
  borderRadius: 10,
  color: '#ffffff',
  backgroundColor: '#007a84',
  pointerEvents: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

function LeadLockOverlay(props) {
  return (
    <div style={overlayStyle} onClick={props.onClick}>
      <div style={overlayButtonStyle}>
        <FeedLockIcon size={32} />
        <span>UNLOCK</span>
      </div>
    </div>
  );
}

LeadLockOverlay.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default LeadLockOverlay;
